import * as CalendarModel from './calendar-model';
import * as ContentModel from './calendar-content-model';
import * as ApiClient from './api-client';
import * as DateShared from './date-shared';

export async function getActivityContent(parkCmsKey: string)
  : Promise<ContentModel.CalendarActivityContentResponseDto | null> {
  return await ApiClient.get<ContentModel.CalendarActivityContentResponseDto>(`calendar/activity-content/${parkCmsKey}`);
}

export async function getOperatingDays(
  propertyStartDate: string,
  propertyEndDate: string,
  operatingExtCalIds: string[],
  featuredExtCalIds: string[]
): Promise<CalendarModel.OperatingDaysResponseDto[] | null> {
  return await ApiClient.post<CalendarModel.OperatingDaysResponseDto[]>(
    `calendar/operating-days`,
    {
      start: propertyStartDate,
      end: propertyEndDate,
      operatingExtCalIds,
      featuredExtCalIds
    });
}

export async function getDailyActivities(
  propertyDate: string,
  extCalendarIds: string[]
): Promise<CalendarModel.ActivityDayScheduleDto[] | null> {
  return await ApiClient.post<CalendarModel.ActivityDayScheduleDto[]>(
    `calendar/activities`,
    {
      date: propertyDate,
      extCalendarIds
    });
}
